import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { BarWave } from 'react-cssfx-loading';
// import { useUnsubscribeMutation } from '../../../redux/public/publicSlice';
import { useUnsubscribeMutation } from '../../../redux/apiSlice';
import { AlertMessage, UnsubscriptionContainer } from '../StyledComponents';

const Unsubscribe = () => {
  const [unsubscribe] = useUnsubscribeMutation();
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const params = useSearchParams();

  const email = params[0].get('email');
  const token = params[0].get('token');

  const handleRemove = async () => {
    try {
      setIsLoading(true);
      const result = await unsubscribe({ email, token });
      if (result.data) {
        setSuccessMessage(result.data.message);
        setErrorMessage('');
      }

      if (result.error) {
        setErrorMessage(result.error.data.message);
        setSuccessMessage('');
      }
    } catch (error) {
      setErrorMessage('Invalid URL. Please use the link sent to your email.');
      setSuccessMessage('');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {
        isLoading
          ? (
            <div className="my-[250px] mx-20">
              <BarWave />
            </div>
          ) : (
            <>
              {
                successMessage || errorMessage
                  ? (
                    <UnsubscriptionContainer>
                      <AlertMessage
                        alertType={successMessage ? 'success' : 'warning'}
                        message={successMessage || errorMessage}
                      />
                    </UnsubscriptionContainer>
                  )
                  : (
                    <UnsubscriptionContainer>
                      <p className="font-light text-center">
                        Are you sure you want to un subscribe from our Newsletter? 😢
                      </p>
                      <button
                        type="button"
                        className="bg-blue-500 md:p-4 px-6 py-2 md:px-8 text-white font-light my-3 hover:bg-blue-700
                        md:font-normal"
                        onClick={handleRemove}
                      >
                        Confirm
                      </button>
                    </UnsubscriptionContainer>
                  )
              }
            </>
          )
      }
    </>
  );
};

export default Unsubscribe;
